if (!String.prototype.format) {
  /* eslint no-extend-native: ["error", { "exceptions": ["String"] }] */
  String.prototype.format = function (...args) {
    return this.replace(/{(\d+)}/g, (match, number) => {
      return typeof args[number] !== 'undefined'
        ? args[number]
        : match
    })
  }
}
